import { createFileRoute, Outlet } from "@tanstack/react-router"
import { LayoutWithSidebar } from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"
import { SideBarProps } from "@/pages/medewerkers/$userId/components/SideBar"
import { SideBar } from "@/pages/profiel/SideBar"

export const Route = createFileRoute("/profiel")({
  component: Parent,
})

function Parent() {
  const sidebarNavigationItems: SideBarProps["sidebarNavigationItems"] = [
    {
      label: "Persoonlijke gegevens",
      to: "/profiel/persoonlijke_gegevens",
    },
    {
      label: "Zakelijke gegevens",
      to: "/profiel/zakelijke_gegevens",
      freelancerOnly: true,
    },
    {
      label: "Lesbevoegdheid",
      to: "/profiel/lesbevoegdheid",
      teacherOnly: true,
    },
    { label: "Dossier", to: "/profiel/dossier" },
    {
      label: "Beschikbaarheid",
      to: "/profiel/beschikbaarheid",
      teacherOnly: true,
    },
    { label: "Agenda", to: "/profiel/agenda", teacherOnly: true },
    { label: "Locaties", to: "/profiel/locaties", teacherOnly: true },
    {
      label: "Groepen",
      to: "/profiel/groepen",
      requiredPermission: { action: "read", entity: "planning" },
    },
  ]

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        sidebar={<SideBar sidebarNavigationItems={sidebarNavigationItems} />}
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
